import React, {useEffect} from 'react';
import Container from '@material-ui/core/Container';
import eulaActions from '../../actions/eula.actions';
import {withPageLayout} from '../../hocs';
import {useDispatch, useSelector} from 'react-redux';
import {selectEula} from '../../selectors/eula.selectors';
import {RootState} from '../..';
import {EulaState} from '../../reducers/eula.reducer';
import {EulaItem} from '../../components';

interface Props {
    messages: Record<string, string>;
}

const EulaView: React.FC<Props> = ({messages}) => {
    const dispatch = useDispatch();
    const eulaState = useSelector<RootState, EulaState>(selectEula);
    const {affiliate} = eulaState || {};

    useEffect(() => {
        if (!affiliate.body) {
            dispatch(eulaActions.getAffiliateAgreement());
        }
    }, []);

    return (
        <Container id="Eula">
            <EulaItem isLoading={affiliate.loading} item={affiliate} />
        </Container>
    );
};

export default withPageLayout(EulaView, {
    skipAffiliateStatusCheck: true,
    skipEditSettingsCheck: true,
    skipLoginCheck: true
});
